export default "__VITE_ASSET__CsRJE9vF__"